import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import IconButtonWithContextMenu from '@wix/da-ds/pkg/Dropdown/Preset/IconButtonWithContextMenu';
import { TOOLTIP_HOVER_DELAY } from '../../../../constants';
import { EditorContext } from '../../../Editor/Context';
import ArrowIcon from './ArrowIcon';
import { popperDropdownConfig } from '../../../../extensions/extension-deviation/constants';
import s from './EditorIconButtonWithContextMenu.scss';
const stdProps = {
    className: 'editor-sub-menu'
};
const EditorIconButtonWithContextMenu = (_param)=>{
    var { items, icon, featureId } = _param, props = _object_without_properties(_param, [
        "items",
        "icon",
        "featureId"
    ]);
    const { ref: editor } = useContext(EditorContext);
    // show the current active icon as the menu icon
    // (NOTE! if there are multiple active marks, the -last- active in
    // the list will be shown as the menu's icon)...
    let activeIconComponent = icon;
    // and, in the submenu, show any active marks as a special icon
    const transformedItems = items.map((item)=>{
        const { featureId: itemFeatureId, IconComponent, isActive } = item, itemProps = _object_without_properties(item, [
            "featureId",
            "IconComponent",
            "isActive"
        ]);
        activeIconComponent = isActive && IconComponent ? IconComponent : activeIconComponent;
        return _object_spread({
            iconClassName: isActive ? s['active-icon'] : undefined,
            icon: IconComponent ? /*#__PURE__*/ React.createElement(IconComponent, {
                disableDefaultColors: true
            }) : undefined,
            biData: BiData({
                evid: 193,
                view: BiContextProvidedValue,
                component: BiContextProvidedValue,
                itemid: BiContextProvidedValue,
                typeid: BiContextProvidedValue,
                preset: (editor === null || editor === void 0 ? void 0 : editor.storage['da-presetId']) || 'unknown',
                feature: itemFeatureId || 'unknown'
            })
        }, itemProps);
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(IconButtonWithContextMenu, _object_spread({
        icon: activeIconComponent,
        size: "large",
        tooltipHoverDelay: TOOLTIP_HOVER_DELAY,
        items: transformedItems,
        standardMenuProps: stdProps,
        popperManagerProps: popperDropdownConfig,
        biData: BiData({
            evid: 193,
            view: BiContextProvidedValue,
            component: BiContextProvidedValue,
            itemid: BiContextProvidedValue,
            typeid: BiContextProvidedValue,
            preset: (editor === null || editor === void 0 ? void 0 : editor.storage['da-presetId']) || 'unknown',
            feature: featureId
        })
    }, props)), /*#__PURE__*/ React.createElement(ArrowIcon, {
        className: s['icon']
    }));
};
EditorIconButtonWithContextMenu.displayName = 'EditorIconButtonWithContextMenu';
export default EditorIconButtonWithContextMenu;

//# sourceMappingURL=EditorIconButtonWithContextMenu.js.map